import { render, staticRenderFns } from "./accompany.vue?vue&type=template&id=64645e59&scoped=true&"
import script from "./accompany.vue?vue&type=script&lang=js&"
export * from "./accompany.vue?vue&type=script&lang=js&"
import style0 from "./accompany.vue?vue&type=style&index=0&id=64645e59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64645e59",
  null
  
)

export default component.exports